var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-md-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("Non hai Preventivi")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Crea Preventivo")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-md-3 align-items-end"
              },
              [
                _c("div", { staticClass: "col-md-4 pb-0" }, [
                  _c("h5", { staticClass: "grey pt-0 pb-0" }, [
                    _vm._v("Totale Preventivi: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(" " + _vm._s(_vm.counts.countPractices))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v("Totale Fatt. quota Clienti: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(
                            _vm._f("formatNumber")(_vm.counts.countCashClient)
                          )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v("Totale Fatt. quota Cessione: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(
                            _vm._f("formatNumber")(_vm.counts.countCashInst)
                          )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-10 col-md-4 center pl-5 pr-5" },
                  [
                    _vm.counts.countCashInst
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.counts.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.counts.countCashInst
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [
                                  _vm._v("Totale Fatt. quota Cessione")
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.searchBy("text", _vm.filterVal)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey mobSearchT" }, [
                        _vm._v("Ricerca Preventivo")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterVal,
                              expression: "filterVal"
                            }
                          ],
                          staticClass: "form-control seachMobButton",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Preventivo o Cognome ....."
                          },
                          domProps: { value: _vm.filterVal },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filterVal = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append " }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btnYellow",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.searchBy("text", _vm.filterVal)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "white",
                                attrs: { icon: "search", size: "sm" }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger mt-2",
                      staticStyle: { width: "68%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "9")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "trash-alt", size: "sm" }
                      }),
                      _vm._v("  Preventivi Archiviati "),
                      _c("b", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " + _vm._s(_vm.counts.hasRemovedPractics) + " "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btnYellow mt-2",
                      staticStyle: { width: "28%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("", "")
                        }
                      }
                    },
                    [_vm._v("\n           Reset\n        ")]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5 " }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
            },
            [
              _vm.loaded
                ? _c("pagination", {
                    attrs: {
                      options: {
                        theme: "bootstrap4",
                        texts: {
                          count:
                            "Visualizzazione da {from} a {to} di {count} Preventivi|{count} Preventivi|Un Preventivo"
                        }
                      },
                      records: _vm.practicesFiltredCount,
                      "per-page": _vm.displayPerPage
                    },
                    on: { paginate: _vm.callback },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    {
                      key: "1231dsdfh32354134",
                      staticClass: "pb-5 mt-4",
                      attrs: {
                        icons: {
                          opened: "<span></span>",
                          closed: "<span></span>"
                        }
                      }
                    },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 9
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-9" },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "Cessionario Finale:\n                    "
                                            ),
                                            item.flow == "poste"
                                              ? _c("b", [
                                                  _vm._v(" Poste Italiane ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "cdp"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Cassa Depositi e Prestiti "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "general"
                                              ? _c("b", [
                                                  _vm._v(" Flusso Base ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "agileenergy"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Agile Energy "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta"
                                              ? _c("b", [
                                                  _vm._v(" Flusso MBFACTA ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta_recovery"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Personalizzato "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "h5",
                                            {
                                              staticClass: "black csLineHeight2"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Preventivo N. "
                                              ),
                                              _c(
                                                "b",
                                                { staticClass: "underline" },
                                                [_vm._v(_vm._s(item.code))]
                                              ),
                                              _vm._v(
                                                "\n                    del " +
                                                  _vm._s(
                                                    _vm
                                                      .moment(item.created_at)
                                                      .format(
                                                        "DD-MM-YYYY HH:mm"
                                                      )
                                                  ) +
                                                  " ( " +
                                                  _vm._s(item.bonus) +
                                                  " )\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v(" Cliente: "),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.client_lastname
                                                    ) +
                                                    " " +
                                                    _vm._s(item.client_name) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                " Indirizzo dell'immobile: "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.building_address
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      item.building_civic
                                                    ) +
                                                    " " +
                                                    _vm._s(item.building_city) +
                                                    " (" +
                                                    _vm._s(
                                                      item.building_province
                                                    ) +
                                                    ") CAP " +
                                                    _vm._s(item.building_zip) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              item.flow != "agileenergy"
                                                ? [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            " Totale Fatturato quota Cliente: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.total_transfer_for_client
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Totale Fatturato quota Cessione: "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "black"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.total_bonus_savings
                                                                  )
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _c("br"),
                                                          _vm._v(
                                                            "Totale Fattura da installatore professionista in subappalto verso AGILE ENERGY\n                         "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "per il materiale e l'installazione, come indicati nel Preventivo: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "green"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.totale_imponibile
                                                                    )
                                                                  ) +
                                                                  "*"
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("small", [
                                                          _vm._v(
                                                            "* Da fatturare "
                                                          ),
                                                          _c("b", [
                                                            _vm._v("senza IVA ")
                                                          ]),
                                                          _vm._v(
                                                            " in quanto operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.\n\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Costo di gestione del Servizio del General Contractor AGILE ENERGY\n                      "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "a supporto della gestione di questa Pratica è pari a:\n                      "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "green"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.price_agile
                                                                  )
                                                                ) +
                                                                " + IVA (22%)"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "che sarà fatturato da AGILE ENERGY verso l'installatore professionista in subappalto\n\n\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.state_agile == 4
                                                      ? [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "pt-1 green"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _c("small", [
                                                                  _vm._v(
                                                                    "\n                          La Lettera di Affidamento ed il Contratto per la fornitura e l’installazione sono in verifica da AGILE ENERGY.\n                          A seguito dell'approvazione "
                                                                  ),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      " verranno inviate al Committente le indicazioni per procedere al pagamento della quota parte relativa alla voce “Totale altri Oneri per il Committente”\n\n                            all'indirizzo e-mail "
                                                                    ),
                                                                    _c(
                                                                      "b",
                                                                      {
                                                                        staticClass:
                                                                          "black"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          '"' +
                                                                            _vm._s(
                                                                              item.client_email
                                                                            ) +
                                                                            '"'
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    ".\n                       "
                                                                  )
                                                                ])
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          item.flow == "poste" &&
                                          _vm.flow_poste_active
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "poste" &&
                                          !_vm.flow_poste_active
                                            ? [
                                                _c(
                                                  "h5",
                                                  { staticClass: "red Bold" },
                                                  [
                                                    _vm._v(
                                                      'Valore nominale di Cessione modificabile liberalmente dall\'aderente ( cliccando "Modifica Preventivo" )\n                    '
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "cdp" &&
                                          _vm.flow_cdp_active
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "acceptInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Conferma Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "cdp" &&
                                          !_vm.flow_cdp_active
                                            ? [
                                                _c(
                                                  "h5",
                                                  { staticClass: "red Bold" },
                                                  [
                                                    _vm._v(
                                                      'Valore nominale di Cessione modificabile liberalmente dall\'aderente ( cliccando "Modifica Preventivo" )\n                    '
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                    Modifica Preventivo\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("br")
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "general"
                                            ? [
                                                _c(
                                                  "h5",
                                                  { staticClass: "red Bold" },
                                                  [
                                                    _vm._v(
                                                      'Valore nominale di Cessione modificabile liberalmente dall\'aderente ( cliccando "Modifica Preventivo" )\n                    '
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "acceptInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Conferma Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "mbfacta"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "mbfacta_recovery"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "agileenergy"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                item.state_agile == 3
                                                  ? _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-green m-2 btn-sm",
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "acceptInvoice",
                                                            params: {
                                                              item: item
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon:
                                                                "clipboard-check",
                                                              size: "1x"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                      Conferma Preventivo\n                    "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-danger m-2 btn-sm mr-md-5 ",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.removeOrder(
                                                    item.id,
                                                    item.code,
                                                    key
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "archive",
                                                  size: "sm"
                                                }
                                              }),
                                              _vm._v(
                                                " Annulla ed Archivia Preventivo\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 col-md-1 center pl-md-0 pr-md-0 pt-3 "
                                        },
                                        [
                                          item.enea_request == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                attrs: {
                                                  src: require("../../assets/images/enea.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.to_get_cadastral_data == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                attrs: {
                                                  src: require("../../assets/images/dcast.png")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-2" }, [
                                        item.flow != "agileenergy"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "inline-block center relative mt-3"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "qrcodeImg mb-3",
                                                  attrs: { src: item.qrcode }
                                                }),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "qrcodeText mt-3 pt-4"
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "Conferma con QRCode"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      item.error_agile != null &&
                                      item.flow == "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull mr-4"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "red" },
                                                        [_vm._v(" Attenzione ")]
                                                      ),
                                                      _vm._v(
                                                        " abbiamo rilevato le seguenti anomalie:"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left pl-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.error_agile) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              3 == 4
                                ? _c(
                                    "template",
                                    {
                                      staticClass: "bbaLightColor",
                                      slot: "content"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-md-12 col-lg-12"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                { staticClass: "black" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Indirizzo dell'immobile"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 col-lg-12 pt-4 pb-3"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                { staticClass: " pt-0 mt-2" },
                                                [
                                                  _vm._v(
                                                    "Totale Fatt. quota Cliente: "
                                                  ),
                                                  _c(
                                                    "b",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              item.total_transfer_for_client
                                                            )
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                { staticClass: " pt-0 mt-2" },
                                                [
                                                  _vm._v(
                                                    "Totale Fatt. quota Cessione: "
                                                  ),
                                                  _c(
                                                    "b",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              item.total_bonus_savings
                                                            )
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasRemovedPractics
                    ? _c(
                        "div",
                        [
                          _vm.hasRemovedPractics
                            ? _c("h5", { staticClass: "text-left black" }, [
                                _vm._v("Preventivi Archiviati")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRemovedPractics
                            ? _c("p", { staticClass: "text-left black Bold" }, [
                                _vm._v(
                                  "Attenzione! I dati contenuti in questa schermata non includono i Preventivi archiviati. "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "badger-accordion",
                            { staticClass: "pb-5 mt-4 greyBg" },
                            _vm._l(_vm.practicesFiltred, function(item, key) {
                              return item.status == 9 && _vm.filter == ""
                                ? _c(
                                    "badger-accordion-item",
                                    {
                                      key: item.code + "_r_" + _vm.countloop,
                                      attrs: { id: "id" + item.code }
                                    },
                                    [
                                      _c(
                                        "template",
                                        {
                                          staticClass: "center",
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-9" },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "\n                          Preventivo N. "
                                                      ),
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "underline"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.code)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                          del " +
                                                          _vm._s(
                                                            _vm
                                                              .moment(
                                                                item.created_at
                                                              )
                                                              .format(
                                                                "DD-MM-YYYY HH:mm"
                                                              )
                                                          ) +
                                                          " ( " +
                                                          _vm._s(item.bonus) +
                                                          " )\n                          per "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.client_name
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.client_lastname
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary m-2 btn-sm",
                                                      attrs: {
                                                        href:
                                                          item.invoice_quotation_pdf,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "print",
                                                          size: "sm"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " visualizza/stampa/scarica\n                        "
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-danger m-2 btn-sm mr-md-5",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.removeOrder(
                                                            item.id,
                                                            item.code,
                                                            "restore"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon:
                                                            "trash-restore-alt",
                                                          size: "sm"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " Ripristina\n                        "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "col-md-3"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "template",
                                        {
                                          staticClass: "bbaLightColor",
                                          slot: "content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 col-lg-12"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Indirizzo dell'immobile"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 col-lg-12"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        item.building_address
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.building_civic
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.building_city
                                                      ) +
                                                      " (" +
                                                      _vm._s(
                                                        item.building_province
                                                      ) +
                                                      ") CAP: " +
                                                      _vm._s(
                                                        item.building_zip
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 col-lg-12"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass: "black pb-0"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Dati dell'intervento"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-6" },
                                                [
                                                  _vm._v(
                                                    "\n                        Tipo: "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "uppercase"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.intervention_type
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-6" },
                                                [
                                                  _vm._v(
                                                    "\n                        Data: "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "uppercase"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .moment(
                                                              item.intervention_date
                                                            )
                                                            .format(
                                                              "DD-MM-YYYY"
                                                            )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v(
                      "Nessun risultato  " +
                        _vm._s(
                          _vm.filterVal != 1 &&
                            _vm.filterVal != 2 &&
                            _vm.filterVal != 3 &&
                            _vm.filterVal != 0
                            ? " per " + _vm.filterVal
                            : ""
                        )
                    )
                  ])
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
            },
            [
              _vm.loaded
                ? _c("pagination", {
                    attrs: {
                      options: {
                        theme: "bootstrap4",
                        texts: {
                          count:
                            "Visualizzazione da {from} a {to} di {count} Preventivi|{count} Preventivi|Un Preventivo"
                        }
                      },
                      records: _vm.practicesFiltredCount,
                      "per-page": _vm.displayPerPage
                    },
                    on: { paginate: _vm.callback },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("div", { staticClass: "col-md-12 pb-0" }, [
        _c("h3", { staticClass: "Regular text-left h0 widthFull" }, [
          _c("b", [_vm._v("Gestione Preventivi")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8b643a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8b643a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/offerte/index.vue
// module id = null
// module chunks = 